import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { API_BASE_URL } from "../utils/api";
import { lsGet, lsSet, lsDel } from "../hooks/expiry";

// Helper to read query params
function useQuery() {
    return new URLSearchParams(window.location.search);
}

/**
 * This page is opened by the Payment Portal after "Place Order".
 * It validates the payment result with your backend, then shows a success/failure alert
 * and redirects the user.
 */
export default function PaymentResult() {
    const q = useQuery();

    // Common PSPs pass something like: status, order_id, reference, or token
    const statusFromPSP = q.get("status");          // e.g. 'success' | 'failed' | 'canceled'
    const message = q.get("message");
    const orderId = q.get("order_id");              // your order/cart id
    const paymentRef = q.get("reference") || q.get("ref") || q.get("transaction_id");
    const sig = q.get("sig") || q.get("signature"); // optional HMAC (if your PSP provides one)

    const [checking, setChecking] = useState(true);

    const STORAGE_KEY = "currentView";
    const safe = "orders";
    const ONE_DAY = 24 * 60 * 60 * 1000;
    useEffect(() => {
        (async () => {
            try {
                // Always verify server-side (don’t trust query alone).
                // Implement this endpoint in your backend to return:
                // { status: 'paid' | 'failed' | 'canceled' | 'pending', order_id, ... }
                // const { data } = await axios.get(`${API_BASE_URL}/payments/verify`, {
                //     params: { order_id: orderId, reference: paymentRef, status: statusFromPSP, sig },
                // });

                const finalStatus = "paid";
                const statusFromPSP = "success";
                

                if (statusFromPSP === "paid" || statusFromPSP === "success") {
                    const { isConfirmed } = await Swal.fire({
                        icon: "info",
                        title: "طلبك قيد المعالجة",
                        // text: message,
                        confirmButtonText: "اذهب إلى طلبياتي",
                        confirmButtonColor: "#CAEA3E",
                        iconColor: "#CAEA3E",
                        background: "#1B1B1B",
                        color: "#FFFFFF",
                    });

                    if (isConfirmed) {
                        // Make App open Orders on load
                        lsSet(STORAGE_KEY, safe, ONE_DAY);
                        // localStorage.setItem("currentView", "orders");
                        // Go back to the SPA entry (App reads currentView and shows Orders)
                        window.location.href = "/";
                    }
                    return;
                }
                if (statusFromPSP === "failed") {
                    const { isConfirmed } = await Swal.fire({
                        icon: "error",
                        title: "فشل العملية",
                        text: message,
                        confirmButtonText: "حسناً",
                        confirmButtonColor: "#CAEA3E",
                        iconColor: "#CAEA3E",
                        background: "#1B1B1B",
                        color: "#FFFFFF",
                    });

                    if (isConfirmed) {
                        // Make App open Orders on load
                        lsSet(STORAGE_KEY, "cart", ONE_DAY);
                        // localStorage.setItem("currentView", "orders");
                        // Go back to the SPA entry (App reads currentView and shows Orders)
                        window.location.href = "/";
                    }
                    return;
                }

                if (finalStatus === "canceled") {
                    await Swal.fire({
                        icon: "info",
                        title: "تم إلغاء العملية",
                        text: "لم يتم خصم المبلغ. بإمكانك المحاولة مرة أخرى.",
                        confirmButtonText: "حسناً",
                        confirmButtonColor: "#CAEA3E",
                        iconColor: "#CAEA3E",
                        background: "#1B1B1B",
                        color: "#FFFFFF",
                    });
                    localStorage.setItem("currentView", "cart"); // so App opens Orders next time
                    window.location.replace("/");
                    return;
                }

                // failed / unknown
                await Swal.fire({
                    icon: "error",
                    title: "تعذّر إتمام الدفع",
                    text: "حدث خطأ أثناء عملية الدفع. يرجى المحاولة لاحقاً.",
                    confirmButtonText: "حسناً",
                    confirmButtonColor: "#CAEA3E",
                    iconColor: "#CAEA3E",
                    background: "#1B1B1B",
                    color: "#FFFFFF",
                });
                window.location.replace("/cart");
            } catch (err) {
                console.error("Verify payment failed:", err);
                await Swal.fire({
                    icon: "error",
                    title: "تعذّر التحقق من حالة الدفع",
                    text: "سنرجعك للسلة للمحاولة مجدداً.",
                    confirmButtonText: "رجوع للسلة",
                    confirmButtonColor: "#CAEA3E",
                    iconColor: "#CAEA3E",
                    background: "#1B1B1B",
                    color: "#FFFFFF",
                });
                window.location.replace("/cart");
            } finally {
                setChecking(false);
            }
        })();
    }, []); // eslint-disable-line

    return (
        <div style={{ minHeight: "60vh", display: "grid", placeItems: "center", color: "#fff" }}>
            {checking ? "جاري التحقق من عملية الدفع..." : null}
        </div>
    );
}
